<table mat-table class="orgApp-duties-in-week-container">
  <ng-container matColumnDef="memberType">
    <th
      mat-header-cell
      class="header-row-border orgApp-table-header-ht orgApp-duties-member-type-row"
      *matHeaderCellDef
    >
      {{ "duties.map_duty_dialog.content.member_type" | translate }}
    </th>
  </ng-container>
  <ng-container matColumnDef="monday">
    <th
      mat-header-cell
      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
      *matHeaderCellDef
    >
      {{ "duties.map_duty_dialog.content.mon" | translate }}
    </th>
  </ng-container>

  <ng-container matColumnDef="tuesday">
    <th
      mat-header-cell
      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
      *matHeaderCellDef
    >
      {{ "duties.map_duty_dialog.content.tue" | translate }}
    </th>
  </ng-container>

  <ng-container matColumnDef="wednesday">
    <th
      mat-header-cell
      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
      *matHeaderCellDef
    >
      {{ "duties.map_duty_dialog.content.wed" | translate }}
    </th>
  </ng-container>

  <ng-container matColumnDef="thursday">
    <th
      mat-header-cell
      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
      *matHeaderCellDef
    >
      {{ "duties.map_duty_dialog.content.thu" | translate }}
    </th>
  </ng-container>

  <ng-container matColumnDef="friday">
    <th
      mat-header-cell
      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
      *matHeaderCellDef
    >
      {{ "duties.map_duty_dialog.content.fri" | translate }}
    </th>
  </ng-container>

  <ng-container matColumnDef="saturday">
    <th
      mat-header-cell
      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
      *matHeaderCellDef
    >
      {{ "duties.map_duty_dialog.content.sat" | translate }}
    </th>
  </ng-container>

  <ng-container matColumnDef="sunday">
    <th
      mat-header-cell
      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
      *matHeaderCellDef
    >
      {{ "duties.map_duty_dialog.content.sun" | translate }}
    </th>
  </ng-container>
  <tr
    mat-header-row
    class="orgApp-header-row"
    *matHeaderRowDef="displayedColumns"
  ></tr>
</table>
<p class="orgApp-duties-in-week-empty-table">
  {{ "duties.map_duty_dialog.content.empty_title" | translate }}
</p>
<hr />
